import { render, staticRenderFns } from "./fraud-form.vue?vue&type=template&id=cc57847c&"
import script from "./fraud-form.vue?vue&type=script&lang=js&"
export * from "./fraud-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports